import { Bank, Card, Error, Loading, Paid } from './components';
import { useStatusDepositContext } from './context';

const StatusDepositContent: React.FunctionComponent = function () {
  const { display } = useStatusDepositContext();
  return (
    <>
      {display === 'bank' && <Bank />}
      {display === 'card' && <Card />}
      {display === 'error' && <Error />}
      {display === 'loading' && <Loading />}
      {display === 'paid' && <Paid />}
    </>
  );
};

export default StatusDepositContent;
